import React from "react";
import "./ValueBadge.css";

function ValueBadge({
  id,
  title,
  titleEnglish,
  status,
  toggleStatus,
  language,
  handleSelectedValue,
}) {
  return (
    <span
      className={status === true ? "active-hobby" : "inactive-hobby"}
      onClick={() => toggleStatus(id)}
      onMouseOver={() => handleSelectedValue(id)}
    >
      {language === "es" ? title : titleEnglish}
    </span>
  );
}

export default ValueBadge;
